import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Mono, Small, Toolbar } from "./AppDataStyles";

/** The GET endpoint for a row, with a copy button. */
export const RowEndpoint = ({ url }) => {
  const [copied, setCopied] = useState(false);

  if (!url) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      const textarea = document.createElement("textarea");
      textarea.value = url;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };

  return (
    <Toolbar>
      <span style={{ fontSize: "11.5px", color: "#a0a6b1" }}>GET</span>
      <Mono style={{ fontSize: "11.5px" }}>{url}</Mono>
      <Small type="button" onClick={copy} title="Copy this endpoint">
        <Icon icon={copied ? "lucide:check" : "lucide:copy"} /> {copied ? "Copied" : "Copy"}
      </Small>
    </Toolbar>
  );
};

export default RowEndpoint;
